import Vue, { PropType } from "vue";
import { ICell } from "js/crossword/types";

export default Vue.extend({
  props: {
    cell: Object as PropType<ICell>,
  },
  render() {
    return <span></span>;
  }
});
